export const Facebook = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.5254 22.75V13.8633H17.5215L17.9531 10.3848H14.5254V8.17578C14.5254 7.66797 14.6312 7.25749 14.8428 6.94434C15.0544 6.63119 15.5156 6.47461 16.2266 6.47461H18.0547V3.37695C17.6146 3.3431 17.1702 3.31348 16.7217 3.28809C16.2731 3.2627 15.8288 3.25 15.3887 3.25C14.0684 3.25 12.9935 3.64355 12.1641 4.43066C11.3346 5.21777 10.9199 6.35612 10.9199 7.8457V10.3848H7.94922V13.8633H10.9199V22.75H14.5254Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};

